// import './App.css';
import { useEffect, useState } from "react";
import { FormControl, TextField, Button, InputLabel, Select, MenuItem, FormControlLabel, Switch } from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";
import TargetSelector from "./targetSelector";
import ReactFlagsSelect from "react-flags-select";
import { updateAnswer, createAnswer } from "../services/api";

const classes = {};

function AnswerForm({ answer, questionId, onSaveSuccess, ...props }) {
  const [languagePartForm, setLanguagePartForm] = useState({ EN: { text: "", placeholder: "", validation_text: "" } });
  const [language, setLanguage] = useState("EN");
  const [languageForSelect, setLanguageForSelect] = useState("GB");

  const [target, setTarget] = useState("");
  const [order, setOrder] = useState("");
  const [redFlag, setRedFlag] = useState(false);
  const [score, setScore] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (answer.answerTRs?.length) {
      let obj = {};
      answer.answerTRs.forEach((tr) => {
        obj[tr.language] = {
          text: tr.text || "",
          additionalInfo: tr.additional_info || "",
          id: tr.id || undefined
        };
      });
      if (!obj["EN"]) {
        setLanguage(obj[answer.answerTRs[0].language]);
      }
      setLanguagePartForm(obj);
    }
  }, [answer]);

  const refreshForm = () => {
    if (answer.id) {
      setTarget(answer.target);
      setOrder(answer.order);
      setRedFlag(answer.red_flag);
      setScore(answer.score);
    } else {
      setTarget("");
      setOrder("");
      setRedFlag(false);
      setScore(0);
    }
  };

  const saveChanges = () => {
    setLoading(true);
    answer.target = target;
    answer.order = order;
    answer.red_flag = redFlag;
    answer.score = score;
    answer.answerTRs = [];
    Object.keys(languagePartForm).forEach((key) => {
      answer.answerTRs.push({
        language: key,
        text: languagePartForm[key].text,
        additional_info: languagePartForm[key].additionalInfo || "",
        id: languagePartForm[key].id || undefined
      });
    });
    if (answer.id) {
      updateAnswer(answer)
        .then((res) => {
          onSaveSuccess(res);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      answer.question_id = questionId;
      createAnswer(answer)
        .then((res) => {
          onSaveSuccess(res);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    refreshForm();
  }, []);

  const handleFieldChange = (setFunction) => {
    return (event) => {
      setFunction(event.target.value);
    };
  };

  const onChangeText = (value) => {
    setLanguagePartForm((oldForm) => {
      let form = { ...oldForm };
      form[language].text = value;
      return form;
    });
  };

  const onChangeAdditionalInfo = (value) => {
    setLanguagePartForm((oldForm) => {
      let form = { ...oldForm };
      form[language].additionalInfo = value;
      return form;
    });
  };

  const onChangeLanguage = (value) => {
    /* TO CHANGE FROM GB TO EN (country to language) */
    let newValue;
    if (value === "GB") {
      newValue = "EN";
    } else {
      newValue = value;
    }

    setLanguage(newValue);
    setLanguageForSelect(value);

    if (!languagePartForm[newValue]) {
      setLanguagePartForm((oldForm) => {
        let form = { ...oldForm };
        form[newValue] = {
          text: "",
          additionalInfo: ""
        };
        return form;
      });
    }
  };

  return (
    <LoadingOverlay active={loading} spinner>
      <div class="bodyModal">
        <FormControl className="inputForms flagSelect">
          <InputLabel id="languageLabelAssessmentSection">Language</InputLabel>
          {/* <Select
            labelId="languageLabelAssessmentSection"
            id="languageAssessmentSection"
            value={language}
            onChange={handleFieldChange(onChangeLanguage)}
          >
            <MenuItem value={"EN"}>English</MenuItem>
            <MenuItem value={"ES"}>Spanish</MenuItem>
          </Select> */}

          <ReactFlagsSelect
            labelId="languageLabelAssessmentSection"
            id="languageAssessmentSection"
            selected={languageForSelect}
            onSelect={(code) => onChangeLanguage(code)}
            countries={["ES", "GB"]}
            customLabels={{ GB: "English", ES: "Spanish" }}
            searchable
          />
        </FormControl>
        
        <FormControl>
        <TextField
            label="Text"
            value={languagePartForm[language].text}
            onChange={handleFieldChange(onChangeText)}
            className="inputForms"
          />
          <TextField
            label="Additional info"
            value={languagePartForm[language].additionalInfo}
            onChange={handleFieldChange(onChangeAdditionalInfo)}
            className="inputForms"
          />
          <TargetSelector {...props} value={target} setValue={setTarget} className="inputForms" />
          <TextField label="Order" value={order} onChange={handleFieldChange(setOrder)} className="inputForms" />
          <TextField label="Score" value={score} onChange={handleFieldChange(setScore)} className="inputForms" />
        </FormControl>
        <FormControlLabel
            control={
              <Switch
                checked={redFlag}
                onChange={(evt) => {
                  setRedFlag(evt.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label="Is red flag"
          />

        <div className="text-center">
          <Button variant="contained" color="primary" onClick={saveChanges} className="btn-main-limber mb-15 mt-15">
            Save
          </Button>
        </div>
      </div>
    </LoadingOverlay>
  );
}

export default AnswerForm;
